<div class="comment-box">
  <div class="title">{{ title }}</div>
  <div class="comments">
    <div *ngIf="loading" l10nTranslate><h3>shared.fetchingComments</h3></div>
    <div miq-entry-comment *ngFor="let comment of comments" [comment]="comment"></div>
  </div>

  <div class="ava-comments" [formGroup]="messageGroup">
    <div class="input-container">
      <mat-form-field appearance="outline">
        <input
          rows="1"
          matInput
          autocomplete="no-autofill"
          [placeholder]="'shared.writeYourComment' | xTranslate"
          formControlName="message"
          (keyup.enter)="sendMessage($event)"
        />
      </mat-form-field>
      <button mat-icon-button color="primary" (click)="sendMessage($event)">
        <mat-icon>send</mat-icon>
      </button>
    </div>
  </div>
  <div></div>
</div>
